import { ref } from "vue";
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';
import { sendMetrik } from '@/utils/metrika'

let modalsInstance; 

export const useModals = () => {

    if (modalsInstance) {
        return modalsInstance;
    }

    const activeModal = ref(false);
    const modalId = ref(null);    
    const modalObj = ref(null);

    const storeRequests = useRequestsStore()
    const storeSettings = useSettingsStore();
   

    const disableScroll = () => {
        lockPadding();
        document.body.classList.add('noscroll');
    }
    
    const enableScroll = () => {
        document.body.classList.remove('noscroll');
        unlockPadding()
    }
   
    const lockPadding = () => {
        const paddingOffset = `${window.innerWidth - document.body.offsetWidth}px`;
        document.body.style.paddingRight = paddingOffset;
        // document.querySelector('.header .container').style.marginRight = '55px';
        // document.querySelector('.header__container').style.marginRight = paddingOffset;
    }
    
    const unlockPadding = () => {
        document.body.style.paddingRight = '0px';
        // document.querySelector('.header .container').style.marginRight = '40px';
    }  

   
    

    const closeModal = () =>{

        if(modalId.value === 'ageNotVerification') {            
            activeModal.value = true;
            modalId.value = 'ageVerification';
        } else {
            activeModal.value = false;
            modalId.value = null;
            enableScroll();
            storeRequests.responseError = '';
        }
    }

    const openModal = (id, object = null) => {
        closeModal();
        disableScroll();
        activeModal.value = true;
        modalId.value = id;   
        modalObj.value = object;  
    }
    
    const triggerQrScan = () => {
        const qrElement = document.getElementById('apm-scan-qr');
        setTimeout(() => {
            const closeApmBtn = document.getElementById('apm-close-widget-button');
            closeApmBtn?.addEventListener('click', () => {
                
            })
        }, 1000)
        if (!storeSettings.isPromoNotStart) {
            openModal('promoNotStart');
        } else if (storeSettings.isPromoEnd  && storeSettings.isPromoNotStart) {
            openModal('promoEnd');
        } else if (qrElement && storeRequests.isAuthenticated) {
            if(storeRequests.userData?.receipt_status === 'upload_available') {
                qrElement.click();
            } else {
                openModal('downloadProhibition')
            }
        } else {
            openModal('authorizationRequired')
        }  
    }

    return modalsInstance = { activeModal, modalId, modalObj, closeModal, openModal, triggerQrScan };
   
}